const customLabels = {
  first: '<<',
  last: '>>',
  previous: '<',
  next: '>',
};

const customStyles = {
  ul: {},
  li: {
    display: 'inline-block',
  },
  a: {
    color: 'var(--purple-dark)',
  },
};

export { customLabels, customStyles };
